import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CartBottomBar = () => {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart.cart);

  const itemCount = cart.reduce((acc, item) => acc + item.count, 0);

  const cartTotal = cart.reduce(
    (acc, item) => acc + item.price * item.count,
    0,
  );

  if (itemCount === 0) return null;

  const goTo = (path) => {
    navigate(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* SAME WIDTH AS MENU CONTAINER */}
      <div className="max-w-6xl mx-auto px-0 lg:px-4 pb-1 mb- 0 bg-navy ">
        <div className="shadow-[0_-4px_20px_rgba(0,0,0,0.08)] px-6 py-4 flex items-center justify-between">
          {/* LEFT */}
          <div
            className="flex items-center gap-4 cursor-pointer"
            onClick={() => goTo("/cart")}
          >
            <div className="bg-neonYellow text-black font-semibold w-8 h-8 flex items-center justify-center rounded-md text-sm">
              {itemCount}
            </div>

            <div className="flex items-center gap-3">
              <span className="font-semibold text-neonYellow text-lg">
                ${cartTotal.toFixed(2)}
              </span>
              {/* 
              <div className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-300 text-gray-500 text-sm">
                i
              </div> */}
            </div>
          </div>

          {/* CHECKOUT BUTTON */}
          <button
            onClick={() => navigate("/cart")}
            className="bg-neonYellow hover:bg-neonYellow hover:text-darkbg transition px-8 py-3 rounded-full font-semibold text-navy track-widest text-sm"
          >
            CHECKOUT
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartBottomBar;
